<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Open menu" class="mat-menu-open-btn">
  <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="before" class="bm-mat-menu">
  <ng-content></ng-content>
</mat-menu>
